import server from '@/request';

// 分类树
export const getCategoryLists = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/category/tree', data);
};

// 修改商品分类
export const updateCategory = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/category/update', data);
};

// 添加商品分类
export const addCategory = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/category/add', data);
};

// 删除分类
export const deleteCategory = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/category/delete', data);
};

// 查询详情
export const detailCategory = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/category/detail', data);
};

// 更新分类状态：禁用-启用分类
export const updateCategoryStatus = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/category/updateStatus', data);
};

// 查询某分类下绑定的品牌信息
export const getCategoryBrandList = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/categoryBrand/getCategoryBrandList', data);
};

// 保存某分类下绑定的品牌信息
export const saveCategoryBrand = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/categoryBrand/saveCategoryBrand', data);
};

// 属性组分页列表
export const getCategoryAttributeGroupPageList = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/categoryAttribute/attributeGroupPageList', data);
};

// 更新属性组
export const updateAttributeGroup = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/categoryAttribute/updateAttributeGroup', data);
};

// 新增属性组
export const addAttributeGroup = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/categoryAttribute/addAttributeGroup', data);
};

// 新增属性项
export const addAttributeItem = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/categoryAttribute/addAttributeItem', data);
};

// 批量新增属性项
export const batchAddAttributeItem = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/categoryAttribute/batchAddAttributeItem', data);
};

// 删除属性组
export const deleteAttributeGroup = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/categoryAttribute/deleteAttributeGroup', data);
};

// 删除属性项
export const deleteAttributeItem = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/categoryAttribute/deleteAttributeItem', data);
};

// 更新属性项
export const updateAttributeItem = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/categoryAttribute/updateAttributeItem', data);
};
